announcementHandler = {
    $panel: $('.panel-announcement'),
    $main: $('main'),
    $html: $('html'),
    $body: $('body'),
    $header: $('header'),
    $lastFocused: null,
    $focusableElements: null,

    closePanel: function () {
        var self = this;

        self.$html.removeClass('disable-scroll');
        self.$header.removeClass('pop-up-is-show');
        self.$panel.addClass('hide');
        $(document).off('keydown.announcement');
    },

    initPanel: function () {
        var self = this;

        if (self.$panel.length > 0 && !self.$panel.hasClass('hide-not-home')) {
            var cookieDate = Cookies.get('announcement-date');
            var date = new Date();
            date.setHours(0, 0, 0, 0);
            var time = date.getTime();

            if (self.$panel.hasClass('type-bar')) {
                self.$panel.removeClass('hide');
                Cookies.remove('announcement-date');
                var panelHeight = self.$panel.innerHeight();
                self.$body.css('--banner-height', panelHeight + 'px');
                self.$main.css('padding-top', panelHeight + 'px');
            } else if (self.$panel.hasClass('type-pop-up')) {
                // uncomment this block if you'd like the popup to always shows
                self.$panel.removeClass('hide');
                self.$html.addClass('disable-scroll');
                self.$header.addClass('pop-up-is-show');
                self.$panel.find('.icon-close.trigg-close').trigger('focus');
                $(document).on('keydown.announcement', function (e) {
                    if (e.key === 'Escape' || e.keyCode === 27) {
                        self.closePanel();
                    }
                });
                // uncomment this block if you'd like the popup to show only once until user's cookies are cleared 
                // if ((!cookieDate || parseInt(cookieDate) < time)) {
                //     self.$panel.removeClass('hide');
                //     self.$html.addClass('disable-scroll');
                //     self.$header.addClass('pop-up-is-show');
                //     Cookies.set('announcement-date', time, { expires: 1 });
                // }

                // WCAG: Save last focused element, move focus into popup
                self.$lastFocused = $(document.activeElement);
                self.$focusableElements = self.$panel.find('a, button, [tabindex]:not([tabindex="-1"])');
                
                setTimeout(function() {
                    if (self.$focusableElements.length) {
                        self.$focusableElements.first().focus();
                    }
                }, 100);
            } else if (self.$panel.hasClass('type-none')) {
                Cookies.remove('announcement-date');
            }

            self.$panel.each(function () {
                $(this).find('.trigg-close').on('click', function () {
                    self._closePopup();
                });
            });

            // WCAG: Escape key closes popup
            if (self.$panel.hasClass('type-pop-up')) {
                $(document).on('keydown.announcement', function (e) {
                    if (e.key === 'Escape' && !self.$panel.hasClass('hide')) {
                        self._closePopup();
                    }
                });

                // WCAG: Focus trapping – keep focus inside the popup
                $(document).on('keydown.announcementTrap', function (e) {
                    if (e.key === 'Tab' && !self.$panel.hasClass('hide') && self.$focusableElements) {
                        var first = self.$focusableElements.first();
                        var last = self.$focusableElements.last();
                        
                        if (e.shiftKey) {
                            if ($(document.activeElement).is(first)) {
                                e.preventDefault();
                                last.focus();
                            }
                        } else {
                            if ($(document.activeElement).is(last)) {
                                e.preventDefault();
                                first.focus();
                            }
                        }
                    }
                });
            }
        }
    },

    _closePopup: function () {
        var self = this;
        
        self.$html.removeClass('disable-scroll');
        self.$header.removeClass('pop-up-is-show');
        self.$panel.addClass('hide');
        
        // Clean up event listeners
        $(document).off('keydown.announcement');
        $(document).off('keydown.announcementTrap');
        
        // WCAG: Move focus to skip-to-content link or first focusable element
        if ($('.skip-link').length) {
            $('.skip-link').focus();
        } else if (self.$lastFocused && self.$lastFocused.length) {
            self.$lastFocused.focus();
        }
        self.$lastFocused = null;
    },

    init: function () {
        var self = this;

        self.initPanel();

        if (self.$panel.hasClass('type-bar')) {
            // recompute panel size due to potential different number of lines
            $(window).on('resize', function () {
                self.initPanel();
            });
        }

    }
}
